import React, { useEffect, useState } from "react";
import {useNavigate, useParams, Link} from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';

import {getStateListAPI, getIndustryTypeAPI, editUserdataAPI , updateUserDataAPI} from "./../../../API/Admin/UserAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
//import {successMesg, errorMesg, infoMessage, warningMesg} from "../../Toaster";




const UserEdit = () =>{

    const { userid } = useParams();
    const [statelist, setStateList] = useState([]);
    const [industrylist, setIndustryList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [txtusername, setTxtUsername] = useState('');
    const [txtpasswd, setTxtPasswd] = useState('**********');
    const [txtname, setTxtName] = useState('');
    const [txtemail, setTxtEmail] = useState('');
    const [txtcontact, setTxtContact] = useState('');
    const [txtacname, setTxtAcname] = useState('');
    const [txtstate, setTxtState] = useState('');
    const [txtindustrytype, setTxtIndustryType] = useState('');
    const [txtusertype, setTxtUsertype] = useState('');
    const navigate = useNavigate();


    useEffect(() => {

        getStateListAPI(setStateList, setLoading);
        getIndustryTypeAPI(setIndustryList, setLoading);
        editUserdataAPI(userid, setTxtUsername, setTxtPasswd, setTxtName, setTxtEmail, setTxtContact, setTxtAcname, setTxtState, setTxtIndustryType, setTxtUsertype, setLoading);

        console.log('>>>>'+industrylist);

    }, []);


    const handleInputUsername = (event) =>{

        setTxtUsername(event.target.value);
    }

    const handleInputPassword = (event) =>{
        
        setTxtPasswd(event.target.value);
    }

    const handleInputName = (event) =>{
        
        setTxtName(event.target.value);
    }

    const handleInputEmail = (event) =>{
        
        setTxtEmail(event.target.value);
    }

    const handleInputContact = (event) =>{
        
        setTxtContact(event.target.value);
    }

    const handleInputAccountName = (event) =>{
        
        setTxtAcname(event.target.value);
    }

    const handleInputState = (event) =>{
        
        setTxtState(event.target.value);
    }

    const handleInputIndustryType = (event) =>{
        
        setTxtIndustryType(event.target.value);
    }

    const handleInputUsertype = (event) =>{
        
        setTxtUsertype(event.target.value);
    }

    /*const resetUserForm = () =>{
        setStateList(0);
        setIndustryList(0);
        setTxtUsername("");
        setTxtPasswd("");
        setTxtName("");
        setTxtEmail("");
        setTxtContact("");
        setTxtAcname("");
        setTxtUsertype(0);
    }*/

    const handleUpdateUser = () =>{

        //showSuccessToast("Hello, Welcome to React");

        //successMesg('Operation successful!');

        //setLoading(true);

        let params = {
                    "username" : txtusername,
                    "password" : txtpasswd,
                    "name" : txtname,
                    "email" : txtemail,
                    "contact" : txtcontact,
                    "accountname" : txtacname,
                    "state" : txtstate,
                    "industrytype" : txtindustrytype,
                    "usertype" : txtusertype,
                    "id": userid
                    };
        
        console.log('params======' + JSON.stringify(params));

        updateUserDataAPI(params, setLoading, navigate);
    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper cardhead">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row">
                        <div className="col">
                            <h3 className="page-title">Modify User</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">                        
                        <div className="card">                            
                            <div className="card-body">
                                <form method="post" name="frmedituser" id="frmedituser">
                                    <div className="mb-3">
                                        <label className="form-label">Username</label>
                                        <input type="text" className="form-control" name="username" id="username" value={txtusername} onChange={handleInputUsername} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <input type="password" className="form-control" name="passwd" id="passwd" value={txtpasswd} onChange={handleInputPassword} disabled />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input type="text" className="form-control" name="name" id="name" value={txtname} onChange={handleInputName} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input type="email" className="form-control" name="email" id="email" value={txtemail} onChange={handleInputEmail} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Contact</label>
                                        <input type="text" className="form-control" name="contact" id="contact" value={txtcontact} onChange={handleInputContact} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Account Name</label>
                                        <input type="text" className="form-control" name="acname" id="acname" value={txtacname} onChange={handleInputAccountName} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">State</label>
                                        <select className="form-control" name="state" id="state" value={txtstate} onChange={handleInputState}>
                                            <option value="">Select</option>
                                            {statelist && statelist.length > 0 ?
                                                (statelist.map(state =>
                                                    (
                                                        <option value={state.id} key={state.id}>{state.name}</option>
                                                    )
                                                )

                                                )
                                            :
                                                <></>    
                                            }
                                            
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Industry Type</label>
                                        <select className="form-control" name="industrytype" id="industrytype" value={txtindustrytype} onChange={handleInputIndustryType}>
                                            <option value="">Select</option>
                                            {industrylist && industrylist.length > 0 ?
                                                (industrylist.map(industry =>
                                                    (
                                                        <option value={industry.id} key={industry.id}>{industry.name}</option>
                                                    )
                                                )

                                                )
                                            :
                                                <></>    
                                            }
                                            
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">User Type</label>
                                        <select className="form-control" name="usertype" id="usertype" value={txtusertype} onChange={handleInputUsertype}>
                                            <option value="">Select</option>
                                            <option value="2">Sales</option>
                                            <option value="3">Telecaller</option>
                                            <option value="4">Publisher</option>
                                            <option value="5">Vendor</option>
                                        </select>
                                    </div>

                                    <div className="text-end">
                                        <button type="button" className="btn btn-primary"  onClick={handleUpdateUser}>
                                            {loading ?
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            :
                                                <p>Update User</p>
                                            }
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default UserEdit;